import {Dispatch} from "redux";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IApplicationData} from "../../types/IApplicationData";

const MULTI_LEAD_APPLICATIONS_ACTIONS_PREFIX = "multi_lead/applications";

export interface IMultiLeadApplication {
    application: IApplicationData;
    recommendedOffer?: IRecommendedOffer;
    recommendedProperty?: IRecommendedProperty;
}
export const appendMultiLeadApplicationsTypes = {
    reset: `${MULTI_LEAD_APPLICATIONS_ACTIONS_PREFIX}_reset`,
    append: `${MULTI_LEAD_APPLICATIONS_ACTIONS_PREFIX}_append`
} as const;

export type IMultiLeadApplicationsResetAction = {
    type: typeof appendMultiLeadApplicationsTypes.reset;
    id: string;
};

export type IMultiLeadApplicationsAppendAction = {
    type: typeof appendMultiLeadApplicationsTypes.append;
    id: string;
    applications: IMultiLeadApplication[];
};

export type IMultiLeadApplicationsActions = IMultiLeadApplicationsResetAction | IMultiLeadApplicationsAppendAction;

export const appendMultiLeadApplicationsForProperties =
    (storeHash: string, recommendedProperties: [IApplicationData, IRecommendedProperty | IPropertyDetail][]) => (dispatch: Dispatch) => {
        const applications = recommendedProperties.map(([application, recommendedProperty]) => ({
            application,
            recommendedProperty
        }));

        dispatch({type: appendMultiLeadApplicationsTypes.append, id: storeHash, applications: applications});
    };

export const appendMultiLeadApplicationsForOffers = (storeHash: string, recommendedOffers: [IApplicationData, IRecommendedOffer][]) => (dispatch: Dispatch) => {
    const applications = recommendedOffers.map(([application, recommendedOffer]) => ({
        application,
        recommendedOffer
    }));

    dispatch({type: appendMultiLeadApplicationsTypes.append, id: storeHash, applications: applications});
};
import {Dispatch} from "redux";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IApplicationData} from "../../types/IApplicationData";

const MULTI_LEAD_APPLICATIONS_ACTIONS_PREFIX = "multi_lead/applications";

export interface IMultiLeadApplication {
    application: IApplicationData;
    recommendedOffer?: IRecommendedOffer;
    recommendedProperty?: IRecommendedProperty;
}
export const appendMultiLeadApplicationsTypes = {
    reset: `${MULTI_LEAD_APPLICATIONS_ACTIONS_PREFIX}_reset`,
    append: `${MULTI_LEAD_APPLICATIONS_ACTIONS_PREFIX}_append`
} as const;

export type IMultiLeadApplicationsResetAction = {
    type: typeof appendMultiLeadApplicationsTypes.reset;
    id: string;
};

export type IMultiLeadApplicationsAppendAction = {
    type: typeof appendMultiLeadApplicationsTypes.append;
    id: string;
    applications: IMultiLeadApplication[];
};

export type IMultiLeadApplicationsActions = IMultiLeadApplicationsResetAction | IMultiLeadApplicationsAppendAction;

export const appendMultiLeadApplicationsForProperties =
    (storeHash: string, recommendedProperties: [IApplicationData, IRecommendedProperty | IPropertyDetail][]) => (dispatch: Dispatch) => {
        const applications = recommendedProperties.map(([application, recommendedProperty]) => ({
            application,
            recommendedProperty
        }));

        dispatch({type: appendMultiLeadApplicationsTypes.append, id: storeHash, applications: applications});
    };

export const appendMultiLeadApplicationsForOffers = (storeHash: string, recommendedOffers: [IApplicationData, IRecommendedOffer][]) => (dispatch: Dispatch) => {
    const applications = recommendedOffers.map(([application, recommendedOffer]) => ({
        application,
        recommendedOffer
    }));

    dispatch({type: appendMultiLeadApplicationsTypes.append, id: storeHash, applications: applications});
};
